import { PopupMenuCtrl } from "@omnia/shared/components/popupMenu/popupMenu"
import { defineDirective, IMapTooltip, IOmniaCommand } from "../../../omnia"
import { INtrReq, INutritionService } from "../../../types"
import { IDashboardContext } from "../types"
import { RequirementsZone } from "@omnia/shared/nutrition/map/requirementsZone";
import { NutrientAppZone } from "@omnia/shared/nutrition/map/nutrientAppZone";


export class MapContextMenuCtrl extends PopupMenuCtrl {

    static create(): ng.IDirective {

        return defineDirective(MapContextMenuCtrl, "shared/components/popupMenu/popupMenu.html", {
            menu: "="
        });
    }

    private menu: IMapTooltip;

    private target: RequirementsZone | NutrientAppZone;

    static $inject = ["$scope", "OmniaNutritionService"];

    constructor(protected $scope: ng.IScope, private svc: INutritionService) {
        super($scope);
    }

    $onInit() {

        if (!this.menu) return;

        this.target = this.menu.data;

        if (this.target instanceof RequirementsZone) {
            this.setupRequirementZoneMenu(this.target);
        }
        else if (this.target instanceof NutrientAppZone) {
            this.setupAppZoneMenu(this.target);
        }
    }

    private setupRequirementZoneMenu(reqZone: RequirementsZone) {

        let commands: IOmniaCommand[];

        let data = <INtrReq>reqZone.zone.Data;
        let hasZones = data && data.NtrReqId && data.Zone;

        if (hasZones) {
            commands = [
                this.createEditReqCommand("Edit zone requirements"),
                this.createEditReqCommand("Edit field requirements", true),
            ];
        }
        else {
            commands = [this.createEditReqCommand("Edit requirements")];
        }

        this.setupCommands(commands);

    }

    private createEditReqCommand(text: string, field?: boolean): IOmniaCommand {
        return {
            text: text,
            icon: "edit",
            foreground: true,
            execute: () => this.executeContextAction(ctxt => ctxt.editRequirements(null, field))
        }
    }

    private executeContextAction(action: (ctxt: IDashboardContext) => void) {

        if (!this.menu) return;

        let ctxt: IDashboardContext = this.menu.context;
        if (!ctxt) return;

        action(ctxt);

        this.menu = null;
        this.$scope.$applyAsync();

    }

    private setupAppZoneMenu(appZone: NutrientAppZone) {

        let commands: IOmniaCommand[] = [
            {
                text: "Edit application zones",
                icon: "edit",
                foreground: true,
                execute: () => this.executeContextAction(ctxt => ctxt.editApplicationZones())
            }
        ];

        this.setupCommands(commands);

    }

    private setupCommands(commands: IOmniaCommand[]) {

        this.commandsGroups = [
            {
                text: null,
                foreground: true,
                commands: commands,
                foregroundCommands: () => commands,
                backgroundCommands: null,
            }
        ];

    }
}
